import { useTranslation } from 'react-i18next';
import { useParams as useParamsOrg } from 'react-router';
import invariant from 'tiny-invariant';

export const useId = (skip?: boolean) => {
  const { t } = useTranslation();
  const { id } = useParamsOrg();
  if (skip) {
    return { id: '' };
  }
  invariant(id, t('invalid-id-error'));
  return { id };
};
